import React, { FC } from "react";
import { Divider, IconButton } from "@mui/material";
import {
  AddCircle as AddCircleIcon,
  RemoveCircle as RemoveCircleIcon,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";

const StyledRowDiv = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
});

const StyledDivider = styled(Divider)({
  width: "35%",
});

const StyledDividerLong = styled(Divider)({
  width: "120%",
  marginTop: 20,
});

interface LabelAddRemoveProps {
  isEnd: boolean;
  index: number;
  addNewNote: () => void;
  removeNote: () => void;
}

const LabelAddRemove: FC<LabelAddRemoveProps> = ({
  isEnd,
  index,
  addNewNote,
  removeNote,
}) => {
  if (isEnd) {
    return (
      <StyledRowDiv>
        <StyledDivider />

        <IconButton onClick={addNewNote} size="large">
          <AddCircleIcon style={{ fontSize: 30 }} color="primary" />
        </IconButton>

        {index !== 0 && (
          <IconButton onClick={removeNote} size="large">
            <RemoveCircleIcon style={{ fontSize: 30, color: "red" }} />
          </IconButton>
        )}

        <StyledDivider />
      </StyledRowDiv>
    );
  }
  return (
    <StyledRowDiv>
      <StyledDividerLong />
    </StyledRowDiv>
  );
};

export default LabelAddRemove;
